import { FC } from 'react';
import {
  Box,
  Grid,
  GridItem,
  IconButton,
  ListItem,
  Stack,
  Tooltip,
  useBoolean,
  Text,
} from '@chakra-ui/react';
import { AddIcon } from '@chakra-ui/icons';
import { MenuCategory } from 'types/menuCategory';

type Props = {
  /** メニューカテゴリーID */
  categoryId: MenuCategory['id'];
  /** メニュー追加 */
  handleClickAddMenu: (categoryId: MenuCategory['id']) => void;
};

export const MenuCategoryNestedListEmpty: FC<Props> = ({
  categoryId,
  handleClickAddMenu,
}) => {
  const [hover, setHover] = useBoolean();

  return (
    <ListItem
      listStyleType="none"
      onMouseEnter={setHover.on}
      onMouseLeave={setHover.off}
      px="16px"
      py="8px"
      borderTopWidth="1px"
      borderStyle="solid"
      borderColor="gray.200"
    >
      <Box
        m={0}
        w="100%"
        h="100%"
        textAlign="start"
        border="none"
        color="primaryList.item.color"
        cursor="pointer"
      >
        <Grid
          templateColumns="0.5fr 1fr 2fr 4fr 1fr 1fr 3fr"
          gap={0}
          justifyItems="start"
          alignItems="center"
        >
          <GridItem />
          <GridItem />
          <GridItem w="100%">
            <Stack spacing="4px" direction="row" justifyContent="flex-end">
              <Tooltip label="メニューを追加する">
                <IconButton
                  onClick={(event) => {
                    event.stopPropagation();
                    handleClickAddMenu(categoryId);
                  }}
                  size="xs"
                  aria-label="メニュー追加"
                  icon={<AddIcon color="white" />}
                  colorScheme="blue"
                  visibility={hover ? 'visible' : 'hidden'}
                />
              </Tooltip>
            </Stack>
          </GridItem>
          <GridItem pl="10px" pr="10px">
            <Text color="gray.500" fontSize="sm">
              このカテゴリーに登録されているメニューはありません
            </Text>
          </GridItem>
          <GridItem />
          <GridItem />
          <GridItem />
        </Grid>
      </Box>
    </ListItem>
  );
};
